import { render, staticRenderFns } from "./yearPlainDetail.vue?vue&type=template&id=2ec8754a&scoped=true&"
import script from "./yearPlainDetail.vue?vue&type=script&lang=js&"
export * from "./yearPlainDetail.vue?vue&type=script&lang=js&"
import style0 from "./yearPlainDetail.vue?vue&type=style&index=0&id=2ec8754a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec8754a",
  null
  
)

export default component.exports